<section id="st-about-us">
    <div class="container">
        <div class="row">
            <div class="col-md-auto col-video">
                <div class="video-wrapper" [innerHtml]="'https://www.youtube.com/watch?v=XYpzN_rZzpI&t=49s&ab_channel=APLGOKOREA' | youtubeFrame: 'ytp-iframe'"></div>
            </div>
            <div class="col-md-auto col-text">
                <div class="row content">
                    <div class="heading">
                        <h2 class="h-large">회사소개</h2>
                        <span class="h-small">(주)퍼플유</span>
                    </div>
                    
                    <p>
                        <span class="block">(주)퍼플유는 삶의 기초가 되는 건강의 가치를 전합니다.</span>
                        <span class="block">사람과 자연의 조화로 만들어진 혁신적인 제품은 행복한 홈 라이프를 제시해</span>
                        <span class="block">더 나은 삶의 가치를 추구합니다. 행복한 삶, 건강한 사회를 만들어가는 </span>
                        <span class="block"> (주)퍼플유와 함께하시기 바랍니다.</span>
                    </p>
                    
                    <a routerLink="aplgo-kr/about-us" class="col-auto w-btn primary-btn medium-btn hover-icon-btn">
                        <span>더 읽기</span>
                        <div class="hover-icon">
                            <img src="/assets/img/icons/arrow-right.svg">
                        </div>
                    </a>
                </div>
                
            </div>
        </div>
    </div>
    
    <div class="elements">
        <div class="element dots-vertical" >
            <img src="/assets/img/elements/dots-vertical.svg">
        </div>
        <div class="element dots-horizontal" >
            <img src="/assets/img/elements/dots-horizontal.svg">
        </div>        
    </div>
</section>